/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_DolarO_36_79 as Componente_DolarO_36_79,
  rec_Componente_qD_113_68 as Componente_qD_113_68,
  rec_JSXRuntime as JSXRuntime,
  rec_Ki as Ki,
  rec_Kx as Kx,
  rec_Mr as Mr,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Sn as Sn,
  rec_Yx as Yx,
  rec_wi as wi,
} from "../../runtime/index.jsx";
export function TarjetaUnidad(e) {
  let t = (0, ReactCompiler.c)(36),
    { unidad: n, totales: r, esAdmin: i, onEditar: a, onEliminar: o } = e,
    s = `/organizacion/${n.id}`,
    c;
  t[0] === n.tipo
    ? (c = t[1])
    : ((c = Yx(n.tipo)), (t[0] = n.tipo), (t[1] = c));
  let l;
  t[2] === n.nivel
    ? (l = t[3])
    : ((l = <Componente_DolarO_36_79 nivel={n.nivel} />),
      (t[2] = n.nivel),
      (t[3] = l));
  let u;
  t[4] !== c || t[5] !== l
    ? ((u = (
        <p
          className={`flex flex-wrap items-center gap-1.5 text-[11px] text-(--text)`}
          children={[c, l]}
        />
      )),
      (t[4] = c),
      (t[5] = l),
      (t[6] = u))
    : (u = t[6]);
  let d;
  t[7] !== n.sedeId || t[8] !== n.sedeNombre
    ? ((d = <Componente_qD_113_68 sedeId={n.sedeId} nombre={n.sedeNombre} />),
      (t[7] = n.sedeId),
      (t[8] = n.sedeNombre),
      (t[9] = d))
    : (d = t[9]);
  let f;
  t[10] !== d || t[11] !== n.nombre
    ? ((f = (
        <h3
          className={`flex flex-wrap items-center gap-2 font-medium text-(--text-h)`}
          children={[n.nombre, d]}
        />
      )),
      (t[10] = d),
      (t[11] = n.nombre),
      (t[12] = f))
    : (f = t[12]);
  let p;
  t[13] !== n.aCargo || t[14] !== n.tipo
    ? ((p = n.aCargo?.length
        ? `${Kx(n.tipo, n.aCargo.length > 1)}: ${n.aCargo.join(`, `)}`
        : `Sin responsable`),
      (t[13] = n.aCargo),
      (t[14] = n.tipo),
      (t[15] = p))
    : (p = t[15]);
  let m;
  t[16] === p
    ? (m = t[17])
    : ((m = <p className={`mt-0.5 text-xs text-(--text)`} children={p} />),
      (t[16] = p),
      (t[17] = m));
  let h = r.proyectos === 1 ? `proyecto` : `proyectos`,
    _ =
      r.unidades > 0 &&
      ` · ${r.unidades} ${r.unidades === 1 ? `equipo` : `equipos`}`,
    v;
  t[18] !== _ || t[19] !== h || t[20] !== r.proyectos
    ? ((v = (
        <p
          className={`mt-1.5 text-[11px] text-(--text)`}
          children={[r.proyectos, ` `, h, _]}
        />
      )),
      (t[18] = _),
      (t[19] = h),
      (t[20] = r.proyectos),
      (t[21] = v))
    : (v = t[21]);
  let y;
  t[22] !== s || t[23] !== v || t[24] !== u || t[25] !== f || t[26] !== m
    ? ((y = <Sn to={s} className={`block pr-10`} children={[u, f, m, v]} />),
      (t[22] = s),
      (t[23] = v),
      (t[24] = u),
      (t[25] = f),
      (t[26] = m),
      (t[27] = y))
    : (y = t[27]);
  let b;
  t[28] !== i || t[29] !== a || t[30] !== o
    ? ((b = i && (
        <div
          className={`absolute right-2.5 top-2.5 flex gap-1 opacity-0 transition group-hover:opacity-100`}
          children={[
            <button
              type={`button`}
              onClick={a}
              aria-label={`Editar`}
              className={`rounded-lg p-1 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
              children={(0, JSXRuntime.jsx)(wi, {
                className: `h-3.5 w-3.5`,
              })}
            />,
            <button
              type={`button`}
              onClick={o}
              aria-label={`Eliminar`}
              className={`rounded-lg p-1 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
              children={<Ki className={`h-3.5 w-3.5`} />}
            />,
          ]}
        />
      )),
      (t[28] = i),
      (t[29] = a),
      (t[30] = o),
      (t[31] = b))
    : (b = t[31]);
  let x;
  t[32] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((x = (
        <Mr
          className={`pointer-events-none absolute bottom-3 right-2.5 h-4 w-4 text-(--text)`}
        />
      )),
      (t[32] = x))
    : (x = t[32]);
  let S;
  return (
    t[33] !== y || t[34] !== b
      ? ((S = (
          <div
            className={`animar-entrada group relative rounded-2xl border border-(--border) bg-(--bg) p-3 transition hover:shadow-(--shadow)`}
            children={[y, b, x]}
          />
        )),
        (t[33] = y),
        (t[34] = b),
        (t[35] = S))
      : (S = t[35]),
    S
  );
}
